import React from 'react';
import classNames from 'classnames';
import { Typography } from 'antd';
import { useIntl } from 'umi';
import styles from './index.less';
import AgentName from '@/components/Agent/AgentName';
import PrettyDate from '@/components/PrettyDate';
import { getIntlTranslation } from '@/utils/intl';

export interface CommentItemProps {
  comment: any;
  openCommentsDrawer: () => void;
}

export default function CommentItem({ comment, openCommentsDrawer }: CommentItemProps) {
  const intl = useIntl();
  const author = comment.new_value?.author;
  const commentText = comment.new_value?.comment;
  const date = comment.created;
  const moreLabel = getIntlTranslation(intl, { id: 'pages.common.more', defaultMessage: 'more' });

  return (
    <div
      onClick={openCommentsDrawer}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.commentItemContainer,
        styles.projectDetailItemContainerClickable,
      )}
    >
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>
          <div className={styles.commentAuthor}>
            {author && <AgentName agent={author} size="small" hideAvatar />}
          </div>
          <span className={styles.commentDate}>
            <PrettyDate date={date} />
          </span>
        </div>
        <div className={styles.projectDetailItemBody}>
          {commentText && (
            <Typography.Paragraph
              className={styles.commentBody}
              ellipsis={{
                rows: 2,
                expandable: true,
                symbol: moreLabel,
                // Expand inline without also triggering the card's open-drawer click.
                onExpand: (e) => e.stopPropagation(),
              }}
            >
              {commentText}
            </Typography.Paragraph>
          )}
        </div>
      </div>
    </div>
  );
}
